import { EnglishFlag } from "@do/ui/components/flags/english";
import { FrenchFlag } from "@do/ui/components/flags/french";
import { GermanyFlag } from "@do/ui/components/flags/germany";
import { ItalyFlag } from "@do/ui/components/flags/italy";
import { NetherlandsFlag } from "@do/ui/components/flags/netherlands";
import { PortugalFlag } from "@do/ui/components/flags/portugal";
import { SpainFlag } from "@do/ui/components/flags/spain";
import { type CountryCode } from "libphonenumber-js/min";

export const BOTTOM_TOLERANCE = 70; // px – how close is "at bottom"
export const SETTLE_DEBOUNCE_MS = 250; // no size changes during this period => "rendered"
export const MAX_USER_MESSAGE_LENGTH = 511;
export const MIN_CHAT_VIEWPORT_HEIGHT_PX = 400;
export const MAX_CARD_BUTTONS = 4;
export const EMOJI_REGEX =
  /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;

export const LOCALES = [
  {
    code: "nl",
    flag: NetherlandsFlag,
  },
  {
    code: "en",
    flag: EnglishFlag,
  },
  {
    code: "fr",
    flag: FrenchFlag,
  },
  {
    code: "es",
    flag: SpainFlag,
  },
  {
    code: "it",
    flag: ItalyFlag,
  },
  {
    code: "de",
    flag: GermanyFlag,
  },
  {
    code: "pt",
    flag: PortugalFlag,
  },
];

export const COUNTRY_BY_LOCALE: Partial<Record<string, CountryCode>> = {
  de: "DE",
  en: "GB",
  es: "ES",
  fr: "FR",
  it: "IT",
  nl: "NL",
  pt: "PT",
};

export enum ButtonStyles {
  Default = "Default",
  CallToAction = "CallToAction",
}
